import {
  CLEAR_FAULT_ERROR,
  ERROR_ASSIGN_PRIVILEGES,
  ERROR_CREATE_EXTERNAL_USER,
  ERROR_DELETE_EXTERNAL_USER,
  ERROR_EXTERNAL_USER,
  ERROR_FAULT,
  ERROR_GET_EXTERNAL_ROLE,
  ERROR_GET_EXTERNAL_ROLE_BY_ID,
  ERROR_GET_EXTERNAL_USER_BY_ID,
  LOADING_ASSIGN_PRIVILEGES,
  LOADING_CREATE_EXTERNAL_USER,
  LOADING_DELETE_EXTERNAL_USER,
  LOADING_EXTERNAL_USER,
  LOADING_GET_EXTERNAL_ROLE,
  LOADING_GET_EXTERNAL_ROLE_BY_ID,
  LOADING_GET_EXTERNAL_USER_BY_ID,
  SUCCESS_ASSIGN_PRIVILEGES,
  SUCCESS_CREATE_EXTERNAL_USER,
  SUCCESS_DELETE_EXTERNAL_USER,
  SUCCESS_GET_EXTERNAL_ROLE,
  SUCCESS_GET_EXTERNAL_ROLE_BY_ID,
  SUCCESS_GET_EXTERNAL_USERS,
  SUCCESS_GET_EXTERNAL_USER_BY_ID,
} from "../../const/actionTypes";
import {
  ASSIGN_PRIVILEGES_Url,
  EXTERNAL_ROLE_Url,
  EXTERNAL_USER_Url,
  GET_ROLE_BY_ID_Url,
} from "../../const/URL";
import { IPrivilege } from "../../interfaces/privilege";
import { ISuccessState } from "../../interfaces/successState";
import { IAddUserFormInput } from "../../pages/settings/users/addUser/AddUser";
import axiosInstance from "../../services/axiosInstance";
import hasRequestError from "../../util/hasRequestError";
import { CHANGEPORTALPASSWORD_Url } from "../../const/URL";
import {
  LOADING_CHANGE_PASSWORD,
  SUCCESS_CHANGE_PASSWORD,
  ERROR_CHANGE_PASSWORD,
} from "../../const/actionTypes";
import { IChangeContactFormInputs } from "../../pages/settings/users/changePortalPassword/changePortalPassword";
import {
  LOADING_PAYMENT,
  SUCCESS_PAYMENT,
  ERROR_PAYMENT,
} from "../../const/actionTypes";
import { CLEAR_PAYMENT_ERROR } from "../../const/actionTypes";
import { PAYMENTSUMMARY_Url } from "../../const/URL";
import { Dispatch } from "redux";
import { title } from "process";

export const getExternalUses = () => {
  return (dispatch: any) => {
    dispatchAction(dispatch, LOADING_EXTERNAL_USER);
    axiosInstance
      .get(EXTERNAL_USER_Url)
      .then((response) => {
        if (!response.data.isSuccess) {
          throw new Error(response.data.message);
        }

        dispatchAction(
          dispatch,
          SUCCESS_GET_EXTERNAL_USERS,
          response.data.dataBundle
        );
      })
      .catch((message) => {
        dispatchAction(
          dispatch,
          ERROR_EXTERNAL_USER,
          message || "external uses failed"
        );
      });
  };
};

export const getExternalUserRole = () => {
  return (dispatch: any) => {
    dispatchAction(dispatch, LOADING_GET_EXTERNAL_ROLE);
    axiosInstance
      .get(EXTERNAL_ROLE_Url)
      .then((response) => {
        if (hasRequestError(response)) {
          throw new Error(response.data.message);
        }

        dispatchAction(
          dispatch,
          SUCCESS_GET_EXTERNAL_ROLE,
          response.data.dataBundle
        );
      })
      .catch((error) => {
        dispatchAction(
          dispatch,
          ERROR_GET_EXTERNAL_ROLE,
          error.message || "external use role failed"
        );
      });
  };
};

export const addExternalUser = (
  obj: IAddUserFormInput,
  setSuccess: React.Dispatch<React.SetStateAction<ISuccessState | undefined>>
) => {
  let objs = {
    title: obj.title,
    name: obj.firstName + " " + obj.lastName,
    email: obj.username,
    username: obj.username,
    password: obj.password,
    contactNumber: obj.contactNumber,
    isActive: obj.status,
    role: {
      id: obj.role,
    },
    customer: {
      id: obj.customer,
    },
    nickName: obj.nickName,
  };

  return (dispatch: any) => {
    dispatchAction(dispatch, LOADING_CREATE_EXTERNAL_USER);
    axiosInstance
      .post(EXTERNAL_USER_Url + "/user-id/" + obj.adminUser, objs)
      .then((response) => {
        if (hasRequestError(response)) {
          throw new Error(response.data.errorMessage);
        }

        setSuccess({
          isSuccess: true,
          message: "User created successfully!",
        });
        dispatchAction(dispatch, SUCCESS_CREATE_EXTERNAL_USER);
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.errorMessage ||
          error.message ||
          "Failed to save user details";
        setSuccess({
          isSuccess: false,
          message: errorMessage,
        });
        dispatchAction(
          dispatch,
          ERROR_CREATE_EXTERNAL_USER,
          error.message || "Failed to save user details"
        );
      });
  };
};

export const deleteExternalUser = (
  userID: number,
  adminUserID: number,
  setSuccess: React.Dispatch<React.SetStateAction<ISuccessState | undefined>>
) => {
  return (dispatch: any) => {
    dispatchAction(dispatch, LOADING_DELETE_EXTERNAL_USER);
    axiosInstance
      .delete(EXTERNAL_USER_Url + "/" + userID + "/user-id/" + adminUserID)
      .then((response) => {
        if (hasRequestError(response)) {
          throw new Error(response.data.errorMessage);
        }
        setSuccess({
          isSuccess: true,
          message: "User Deleted Successfully",
        });
        dispatchAction(dispatch, SUCCESS_DELETE_EXTERNAL_USER);
        dispatch(getExternalUses());
      })
      .catch((error) => {
        setSuccess({
          isSuccess: false,
          message: error.message,
        });
        dispatchAction(
          dispatch,
          ERROR_DELETE_EXTERNAL_USER,
          error.message || "Failed to save user details"
        );
      });
  };
};

export const getExternalUserRoleById = (roleId: number) => {
  return (dispatch: any) => {
    dispatchAction(dispatch, LOADING_GET_EXTERNAL_ROLE_BY_ID);
    axiosInstance
      .get(GET_ROLE_BY_ID_Url + "/" + roleId)
      .then((response) => {
        if (hasRequestError(response)) {
          throw new Error(response.data.message);
        }

        dispatchAction(
          dispatch,
          SUCCESS_GET_EXTERNAL_ROLE_BY_ID,
          response.data.dataBundle
        );
      })
      .catch((error) => {
        dispatchAction(
          dispatch,
          ERROR_GET_EXTERNAL_ROLE_BY_ID,
          error.message || "external use role failed"
        );
      });
  };
};

export const getExternalUserById = (userID: number, adminUserID: number) => {
  return (dispatch: any) => {
    dispatchAction(dispatch, LOADING_GET_EXTERNAL_USER_BY_ID);
    axiosInstance
      .get(EXTERNAL_USER_Url + "/" + userID + "/user-id/" + adminUserID)
      .then((response) => {
        if (hasRequestError(response)) {
          throw new Error(response.data.message);
        }

        dispatchAction(
          dispatch,
          SUCCESS_GET_EXTERNAL_USER_BY_ID,
          response.data.dataBundle
        );
      })
      .catch((error) => {
        dispatchAction(
          dispatch,
          ERROR_GET_EXTERNAL_USER_BY_ID,
          error.message || "external uses failed"
        );
      });
  };
};

export const assignPrivilegeToExternalUser = (
  userId: string,
  privileges: IPrivilege[],
  setState: React.Dispatch<React.SetStateAction<IPrivilege[] | undefined>>,
  setSuccess: React.Dispatch<React.SetStateAction<ISuccessState | undefined>>
) => {
  const formData = new FormData();
  const privilegeIds = privileges.map((privilege) => privilege.id);
  formData.append("privilegeIds", privilegeIds.join(","));
  return (dispatch: any) => {
    dispatchAction(dispatch, LOADING_ASSIGN_PRIVILEGES);
    axiosInstance
      .post(ASSIGN_PRIVILEGES_Url + "/" + userId + "/privileges", formData)
      .then((response) => {
        if (hasRequestError(response)) {
          throw new Error(response.data.message);
        }

        setState(response.data.dataBundle.privileges as IPrivilege[]);
        setSuccess({
          isSuccess: true,
          message: "Assigned privilege successfully!",
        });
        dispatchAction(dispatch, SUCCESS_ASSIGN_PRIVILEGES);
      })
      .catch((error) => {
        setSuccess({
          isSuccess: false,
          message: "Failed to assign privileges",
        });
        dispatchAction(
          dispatch,
          ERROR_ASSIGN_PRIVILEGES,
          error.message || "Failed to save user details"
        );
      });
  };
};
export interface IChangePortalPassword {
  oldPassword: string;
  newPassword: string;
}
export interface IChangePasswordResponse {
  dataBundle: number;
  isSuccess: boolean;
  errorMessage: string;
  successMessage: string;
}

export const changePortalPassword = (
  data: IChangeContactFormInputs,
  setSuccess: React.Dispatch<React.SetStateAction<string | null>>
) => {
  const request: IChangePortalPassword = {
    oldPassword: data.oldPassword,
    newPassword: data.newPassword,
  };

  return (dispatch: Dispatch) => {
    dispatch({ type: LOADING_CHANGE_PASSWORD });
    axiosInstance
      .post(CHANGEPORTALPASSWORD_Url, request)
      .then((response) => {
        const data: IChangePasswordResponse = response.data;
        setSuccess(data.successMessage || "Password changed successfully!");
        dispatch({ type: CLEAR_FAULT_ERROR });
        return response;
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.errorMessage || "Failed to change password";
        dispatch({
          type: ERROR_FAULT,
          payload: errorMessage,
        });
        throw new Error(errorMessage);
      });
  };
};

export interface IPaymentRequest {
  amount: string;
  accountNo: string;
}

export interface IPaymentResponse {
  isSuccess: boolean;
  errorMessage?: string;
  successMessage?: string;
}

export const processPayment = (
  data: IPaymentRequest,
  setSuccess: React.Dispatch<React.SetStateAction<string>>
) => {
  const request = new URLSearchParams({
    vpc_Amount: data.amount,
    EventSource: data.accountNo,
  }).toString();

  return (dispatch: any) => {
    dispatchAction(dispatch, LOADING_PAYMENT);

    axiosInstance
      .post(PAYMENTSUMMARY_Url, request, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
      .then((response) => {
        const data: IPaymentResponse = response.data;
        if (data.isSuccess) {
          setSuccess(data.successMessage || "Payment successful!");
        } else {
          throw new Error(data.errorMessage || "Payment failed!");
        }
        dispatchAction(dispatch, CLEAR_PAYMENT_ERROR);
        return response;
      })
      .catch((error) => {
        dispatchAction(
          dispatch,
          ERROR_PAYMENT,
          error.message || "Something went wrong!"
        );
        throw error;
      });
  };
};

const dispatchAction = (dispatch: any, type: string, payload?: any) => {
  dispatch({
    type: type,
    payload: payload,
  });
};
